module.exports = __webpack_public_path__ + "media/images/undraw/matching/firmware-87863682ccb2202a6498d5dea47bb43d.png";